import {
  IDTF_ECG_TABLE_DATA_REQUEST,
  IDTF_ECG_TABLE_DATA_SUCCESS,
  IDTF_ECG_TABLE_DATA_FAILURE,
  IDTF_SELECTED_PATIENT,
  IDTF_SELECTED_RECORDING,
} from './types';

const initialState = {
  recordings: {
    isFetching: false,
    data: [],
    error: {},
  },
  selectedPatinet: {},
  selectedRecording: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [IDTF_ECG_TABLE_DATA_REQUEST]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: true,
      data: [],
      error: {},
    },
  }),
  [IDTF_ECG_TABLE_DATA_SUCCESS]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: action.payload,
      error: {},
    },
  }),
  [IDTF_ECG_TABLE_DATA_FAILURE]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: [],
      error: 'failed',
    },
  }),
  [IDTF_SELECTED_PATIENT]: (state, action) => ({
    ...state,
    selectedPatinet: action.payload,
  }),
  [IDTF_SELECTED_RECORDING]: (state, action) => ({
    ...state,
    selectedRecording: action.payload,
  }),
};

//
// Reducer
// ------------------------------------
export const KardiaRxIDTFEcgTable = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxIdtf/KardiaRxIDTFEcgTableReducers.js